/**
 * Reconnect.
 *
 * Upstream rebuilt the connection from the `connect`/`ip` URL query
 * params and reopened the socket in place. webCOA has no such params
 * (it's single-server, auto-connecting from config.json), so that path
 * reconnected to an empty string and effectively never worked.
 *
 * Because the client establishes its connection automatically on load,
 * a full reload IS a clean reconnect: it re-runs config load, asset-base
 * setup and the handshake exactly as a fresh visit would. This is
 * deterministic and avoids the stale-state pitfalls of an in-place
 * socket reopen. The IC log is not preserved across a reconnect; users
 * who want to keep it can export it first (Save chat log).
 */
export function ReconnectButton() {
  const errortext = document.getElementById("client_errortext");
  if (errortext) errortext.textContent = "Reconnecting...";
  window.location.reload();
}
window.ReconnectButton = ReconnectButton;
